import { configureStore } from "@reduxjs/toolkit";
import monitorReducersEnhancer from "./enhancers/monitorReducer";
import loggerMiddleware from "./middleware/logger";
import rootReducer from "./reducers/index";

const isDev = process.env.NODE_ENV !== "production";

export default function configureAppStore(preloadedState) {
	const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      isDev ? getDefaultMiddleware().concat(loggerMiddleware) : getDefaultMiddleware(),
    preloadedState,
    devTools: isDev,
    enhancers: (getDefaultEnhancers) =>
      isDev ? getDefaultEnhancers().concat(monitorReducersEnhancer) : getDefaultEnhancers(),
  });

	if (isDev && module.hot) {
		module.hot.accept("./reducers", () => store.replaceReducer(rootReducer));
	}
	
	return store;
}
